import "./App.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "react-phone-input-2/lib/style.css";
import "react-datepicker/dist/react-datepicker.css";
import "./scss/main.scss";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ToastContainer } from "react-toastify";
import configureStoreProd from "./config/configureStore.prod";
import NotFoundPage from "./pages/NotFoundPage";
import Login from "./pages/auth/login";
import Forgotpassword from "./pages/auth/forgotpassword";
import Resetpassword from "./pages/auth/resetpassword";
import ChangePassword from "./pages/auth/changepassword";
import Dashboard from "./pages/dashboard";
import Profile from "./pages/auth/profile";
import EditProfile from "./pages/auth/profile/editprofile";
import Roles from "./pages/roles";
import AddEditRole from "./pages/roles/AddEdit";
import RoleDetails from "./pages/roles/View";
import SubAdmin from "./pages/subadmin";
import AddEditSubAdmin from "./pages/subadmin/AddEdit";
import SubAdminDetail from "./pages/subadmin/View";
import Users from "./pages/users";
import UserDetail from "./pages/users/View";
import AddEditUser from "./pages/users/AddEdit";
import Category from "./pages/categories";
import AddEditCategory from "./pages/categories/AddEdit";
import ViewCategory from "./pages/categories/View";
import Discount from "./pages/Discount";
import AddEditDiscount from "./pages/Discount/AddEdit";
import DiscountDetail from "./pages/Discount/View";
import Blogs from "./pages/Blogs";
import AddEditBlog from "./pages/Blogs/AddEdit";
import BlogDetail from "./pages/Blogs/View";
import PromoCode from "./pages/PromoCode";
import AddEditPromoCode from "./pages/PromoCode/AddEdit";
import PromoCodeDetail from "./pages/PromoCode/View";
import Cards from "./pages/Cards";
import AddEditCard from "./pages/Cards/AddEdit";
import CardDetail from "./pages/Cards/View";
import SubCategories from "./pages/SubCategories";
import AddEditSubCategory from "./pages/SubCategories/AddEdit";
import ViewSubCategory from "./pages/SubCategories/View";
import Envelope from "./pages/Envelope";
import AddEditEnvelope from "./pages/Envelope/AddEdit";
import EnvelopeDetail from "./pages/Envelope/View";
import Audios from "./pages/Audios";
import AddEditAudio from "./pages/Audios/AddEdit";
import ViewAudio from "./pages/Audios/View";
import ContactUs from "./pages/Contactus";
import AddEditContent from "./pages/Contents/AddEdit";
import Content from "./pages/Contents";
import ContactDetail from "./pages/Contactus/view";
import Faq from "./pages/Faq";
import EditFAQ from "./pages/Faq/AddEdit";
import FaqDetail from "./pages/Faq/view";
import Transactions from "./pages/Transactions";
import TransactionDetail from "./pages/Transactions/view";

const { persistor, store } = configureStoreProd();

function App() {
  const routes = [
    { url: "*", element: <NotFoundPage /> },
    { url: "/", element: <Navigate to="/login" /> },
    { url: "/login", element: <Login /> }, // Auth Routes
    { url: "/forgotpassword", element: <Forgotpassword /> },
    { url: "/resetpassword", element: <Resetpassword /> },
    { url: "/changepassword", element: <ChangePassword /> },
    { url: "/dashboard", element: <Dashboard /> }, // Dashboard & Profile Routes
    { url: "/profile", element: <Profile /> },
    { url: "/profile/edit", element: <EditProfile /> },
    { url: "/roles", element: <Roles /> }, // Role Module Routes
    { url: "/roles/add", element: <AddEditRole /> },
    { url: "/roles/edit/:id", element: <AddEditRole /> },
    { url: "/roles/detail/:id", element: <RoleDetails /> },
    { url: "/subadmin", element: <SubAdmin /> },  // Sub Admin Module Routes
    { url: "/subadmin/add", element: <AddEditSubAdmin /> },
    { url: "/subadmin/edit/:id", element: <AddEditSubAdmin /> },
    { url: "/subadmin/detail/:id", element: <SubAdminDetail /> },
    { url: "/users", element: <Users /> },  // Users Module Routes
    { url: "/users/add", element: <AddEditUser /> },
    { url: "/users/edit/:id", element: <AddEditUser /> },
    { url: "/users/detail/:id", element: <UserDetail /> },
    { url: "/category", element: <Category /> }, // Category Module Routes
    { url: "/category/add", element: <AddEditCategory /> },
    { url: "/category/edit/:id", element: <AddEditCategory /> },
    { url: "/category/detail/:id", element: <ViewCategory /> },
    { url: "/subcategory", element: <SubCategories /> }, // Sub Category Module Routes
    { url: "/subcategory/add", element: <AddEditSubCategory /> },
    { url: "/subcategory/edit/:id", element: <AddEditSubCategory /> },
    { url: "/subcategory/detail/:id", element: <ViewSubCategory /> },
    { url: "/discount", element: <Discount /> }, // Discount Module Routes
    { url: "/discount/add", element: <AddEditDiscount /> },
    { url: "/discount/edit/:id", element: <AddEditDiscount /> },
    { url: "/discount/detail/:id", element: <DiscountDetail /> },
    { url: "/card", element: <Cards /> }, // Card Module Routes
    { url: "/card/add", element: <AddEditCard /> },
    { url: "/card/edit/:id", element: <AddEditCard /> },
    { url: "/card/detail/:id", element: <CardDetail /> },
    { url: "/blog", element: <Blogs /> }, // Blogs Module Routes
    { url: "/blog/add", element: <AddEditBlog /> },
    { url: "/blog/edit/:id", element: <AddEditBlog /> },
    { url: "/blog/detail/:id", element: <BlogDetail /> },
    { url: "/promocode", element: <PromoCode /> }, // Promo Code Module Routes
    { url: "/promocode/add", element: <AddEditPromoCode /> },
    { url: "/promocode/edit/:id", element: <AddEditPromoCode /> },
    { url: "/promocode/detail/:id", element: <PromoCodeDetail /> },
    { url: "/envelope", element: <Envelope /> }, // Envelope Module Routes
    { url: "/envelope/add", element: <AddEditEnvelope /> },
    { url: "/envelope/edit/:id", element: <AddEditEnvelope /> },
    { url: "/envelope/detail/:id", element: <EnvelopeDetail /> },
    { url: "/audio", element: <Audios /> }, // Audio Module Routes
    { url: "/audio/add", element: <AddEditAudio /> },
    { url: "/audio/edit/:id", element: <AddEditAudio /> },
    { url: "/audio/detail/:id", element: <ViewAudio /> },
    { url: "/faq", element: <Faq /> }, // FAQ Module Routes
    { url: "/faq/edit/:id", element: <EditFAQ /> },
    { url: "/faq/add", element: <EditFAQ /> },
    { url: "/faq/detail/:id", element: <FaqDetail /> },
    { url: "/content", element: <Content /> }, // Content Module Routes
    { url: "/content/add", element: <AddEditContent /> },
    { url: "/content/edit/:id", element: <AddEditContent /> },
    { url: "/contactus", element: <ContactUs /> }, // Contact Us Module Routes
    { url: "/contactus/detail/:id", element: <ContactDetail /> },
    { url: "/transaction", element: <Transactions /> }, // Transaction Module Routes
    { url: "/transaction/detail/:id", element: <TransactionDetail /> },
  ];

  return (
    <>
      <Provider store={store}>
        <PersistGate loading={"loading ..."} persistor={persistor}>
          <Router>
            <Routes>
              {routes.map((itm, index) => {
                return <Route path={itm.url} element={itm.element} key={index} />;
              })}
            </Routes>
          </Router>
        </PersistGate>
      </Provider>
      <div id="loader" className="loaderDiv d-none">
        <div>
          <img src="/assets/img/loader.gif" alt="logo" className="loaderlogo" />
        </div>
      </div>
      <ToastContainer autoClose={2000} position="top-right" />
    </>
  );
}

export default App;
